/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect } from 'react';
import { useTheme } from '@mui/material';
import { Container, Grid } from 'nxg-ui-wrapper';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import { SignIn, formFields } from '../../components/SignIn';
import AuthenticatedProvider from '../../store/provider';
import styles from './App.module.css';
import Template from '../../components/Template';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Hub } from 'aws-amplify/utils';
import { TextCommon, RouteCommon, BaseCommon } from 'src/common';

const router = createBrowserRouter([{ path: '*', Component: Template }]);

const App = (): JSX.Element => {
    const theme = useTheme();
    useEffect(() => {
        const unsubscribe = Hub.listen(TextCommon.AUTH_STATE, ({ payload }): void => {
            if (payload.event === BaseCommon.AUTH_EVENT_TYPE.SIGNED_IN) {
                window.location.href = RouteCommon.DATA_IMPORTER_SCREEN;
            }
        });
        return () => unsubscribe();
    }, []);
    return (
        <Container maxWidth={false} sx={{ bgcolor: theme.palette.grey[200] }}>
            <Grid className={styles.wrapper} container direction="column">
                <Grid className={styles.bodyWrapper} container direction="column">
                    <Authenticator className={styles.authenticator} formFields={formFields} hideSignUp={true} components={SignIn}>
                        <AuthenticatedProvider>
                            <RouterProvider router={router} />
                        </AuthenticatedProvider>
                    </Authenticator>
                </Grid>
            </Grid>
        </Container>
    );
};

export default App;
